import styled from '@emotion/styled';
import Section from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemFields/Section';

const SectionWithFirstSectionNameFormMarginCorrection = styled(Section)({
  ':first-of-type .section-name-form': {
    marginTop: -24,
  },
});

export default SectionWithFirstSectionNameFormMarginCorrection;
